import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import React from 'react';

const prefix = 'serverErrorPage';

export function ServerErrorPage() {
  const email = useSelector((state) => state.auth.user.email);
  const helpMail = window.config.supportEmail;
  const header = <FormattedMessage id={`${prefix}.header`} defaultMessage={'Server Error'} />;
  const subheader = (
    <FormattedMessage
      id={`${prefix}.subheader`}
      defaultMessage={`Sorry, we were unable to handle your request. Please contact support ${helpMail}.`}
      values={{ helpMail }}
    />
  );
  const reInitiate = (
    <FormattedMessage
      id={`${prefix}.reInitiate`}
      defaultMessage={`You can ask the requester to re-initiate the signing workflow for your ${email}.`}
      values={{ email }}
    />
  );

  return (
    <div className="view-error-page">
      <div className="ui hidden divider"></div>
      <div className="custom-header mark">{header}</div>
      <div className="description">
        <p>
          {subheader} {email && <span> {reInitiate} </span>}
        </p>
      </div>

      <div className="content">
        <div className="center aligned custom-icon">
          <img className="ui centered huge image error-image" src="/matrix-zenner.gif" alt="unlink" />
        </div>
      </div>
    </div>
  );
}
